import { Helmet } from 'react-helmet';

interface Props {
  title: string;
}

const CustomHead = (props: Props): React.ReactElement => {
  const { title } = props;
  const siteName = 'CMCOS[コムコス]';
  const type = 'website';
  const imagePath = 'https://cmcos-co2.com/ogpImage.png';
  const currentURL = window.location.href;
  const twitterCard = 'summary_large_image';

  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={imagePath} />
      <meta property="og:url" content={currentURL} />
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:image" content={imagePath} />

      {/* 初期リリース時は会員登録ページをnoindex設定 */}
      {location.pathname === '/auth/register' && (
        <meta name="robots" content="noindex"></meta>
      )}
    </Helmet>
  );
};
export default CustomHead;
